(function($) {
	
    $.fn.wrapInTag = function (keywords) {

        if (typeof keywords != 'undefined' && keywords.length>0) {
            var tag = 'strong',
                words = keywords.split(/\s*,\s*/),
                regex = new RegExp(words.join('|'), 'gi'),
                replacement = '<' + tag + '>$&</' + tag + '>';
            return this.html(function () {
                return $(this).text().replace(regex, replacement);
            });
        }
    };

    $.fn.countHits = function (keywords) {

        var counter = 0;

        if (typeof keywords != 'undefined' && keywords.length>0) {
            var text = $(this).text();
            var words = keywords.split(/\s*,\s*/);
            for(var i = 0; i < words.length; i++) {
                var regex = new RegExp(words[i], 'gi');
                counter += ((text.match(regex) || []).length);
            }
        }

        return counter;

    };

    $.fn.getTarget = function(split_str) {
		var return_str = '';
		var target = $(this).attr('href');
		var target_array = target.split(split_str);
		var array_length = target_array.length;

		if (array_length>0) {
			var last = (array_length)-1;
			return_str = target_array[last];
		}
		return return_str;
	};

}(jQuery));